module.exports = __webpack_public_path__ + "static/media/buy.d196f1e5.svg";